import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function crc(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@crc/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@crc/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@crc/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@crc/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@crc/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@crc/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}